"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var action_1 = require("../../action");
var listen = function (element, events, options) { return action_1.default(function (_a) {
    var update = _a.update;
    var eventNames = events.split(' ').map(function (eventName) {
        element.addEventListener(eventName, update, options);
        return eventName;
    });
    return {
        stop: function () { return eventNames.forEach(function (eventName) { return element.removeEventListener(eventName, update, options); }); }
    };
}); };
exports.default = listen;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/popmotion/input/listen/index.js
// module id = 29
// module chunks = 112359326995148 213534597649335 241203398517478